import {Stack, Text} from '@treatwell/ui';
import {useTranslation} from 'react-i18next';
import {FooterContainer} from '../components/Footer';
import {GridLayout, PageContainer} from '../pages';
import layoutStyles from '../pages/Layout.module.css';
import {GenericHeader} from './GenericHeader';
import styles from './ReschedulingPeriodOverdueError.module.css';
export const ReschedulingPeriodOverdueError = () => {
  const {t} = useTranslation();
  const label = t('reschedule.error.overdue');
  return (
    <div className={layoutStyles.root}>
      <GenericHeader />
      <div className={layoutStyles.main}>
        <PageContainer fixedHeight>
          <GridLayout>
            <div className={styles.container}>
              <Stack fullHeight align="center" justify="center">
                <Text as="p" type="mdHeader" className={styles.text}>
                  {label}
                </Text>
              </Stack>
            </div>
          </GridLayout>
        </PageContainer>
      </div>
      <FooterContainer />
    </div>
  );
};
